<script setup lang="ts">
import { WifiOffIcon } from "lucide-vue-next";
import { computed } from "vue";

type OfflineBannerVariant = "default" | "threads-list" | "thread-show";

interface Props {
  variant?: OfflineBannerVariant;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "default",
});

const message = computed(() => {
  if (props.variant === "thread-show") {
    return "Estás sin conexión. Podés leer hilos guardados y dejar mensajes en cola.";
  }
  if (props.variant === "threads-list") {
    return "Estás sin conexión. Mostrando la última copia guardada de tus hilos.";
  }
  return "Estás sin conexión.";
});
</script>

<template>
  <div
    class="flex items-center gap-2 rounded-xl border border-amber-400 bg-amber-100 px-4 py-2.5 text-xs font-medium text-amber-900 dark:border-amber-500/60 dark:bg-amber-950/60 dark:text-amber-200"
  >
    <WifiOffIcon class="size-4 shrink-0" />
    {{ message }}
  </div>
</template>
